import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const ContentMatchingSearchPage = withSuspense(lazy(() => import('./content-matching')));
export default ContentMatchingSearchPage;
